import React from 'react';
import { AiFillLeftCircle } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import { rootUrl } from '../../App';
import { useThemeColor } from '../../hooks/useThemeColor';

const PinUpdateAuthHeader = ({ sliderImgList = null }) => {
    const navigate = useNavigate();

    const { colorMode } = useThemeColor();

    return (
        <div className="row gx-0 py-0 d-flex justify-content-center align-items-center">
            <div className="col-12">
                {
                    sliderImgList &&
                    <div className="position-relative">
                        <img className="w-100 single-banner" src={rootUrl + sliderImgList[0]?.image} alt={sliderImgList[0]?.alt_text} />
                        <div className="overlay"></div>
                    </div>
                }
            </div>
        </div>
    );
};

export default PinUpdateAuthHeader;